import { useEffect, useState } from "react";
import { _single, _UBLInvoice } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectBusinessCore } from "../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { BasicButton } from "../../theme/Component/BasicButton"
import { BasicPage } from "../../theme/Component/BasicPage"
import { FileInput } from "../../theme/Component/FileInput";
import { InputDate } from "../../theme/Input/InputDate";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { SelectAccountantConceptCatalogForSalesInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSupplierInvoice";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import { SelectProject } from "../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import usePaginator from "../../theme/Component/usePaginator";
import { AccountEditor } from "../../editor/AccountEditor";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor";

import { CreateUBLInvoiceItems } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiveItem";
import { SelectRemissionStateConstantsFromProductionOrder } from "../../contabilidad/CatalogoDocumentosUBL/Selectores/SelectRemissionStateConstantsFromProductionOrder";
import { SelectRemissionStateConstantsFromStore } from "./Selectores/SelectRemissionStateConstantsFromStore";

export interface DocumentPDF {
    MediaContext: string;
    Media: string;
    Filename: string;
    Type: string;
    URLLink: string | null;
}

interface formIni {
    IDAccountSupplier: number;
    IDCustomer: number;
    UBLDocumentType: number;
    Year: number;
    Month: number;
    State: number;

}

export const UBLInvoiceInventory = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLInvoice);
    const [form, setForm] = useState<Partial<formIni>>({
        Year: _single.getCurrenYear(),
    })
    const [row, setRow] = useState<any>({});
    const [recordDate, setRecordDate] = useState<any>();
    const [recordStore, setRecordStore] = useState<number>();
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [document, setDocument] = useState<any>([]);
    const [documentError, setDocumentError] = useState<any>([]);
    const paginador = usePaginator();
    const [registers, setRegisters] = useState<number>(15)

    const [modalB, setModalB] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalVisor, setModalVisor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (form.Year) {
            getLista()
        }
    }, [paginador.page])

    const getLista = () => {
        instance.getUblInvoiceCatalogProductionOrder(null, form.IDCustomer, null, form.Year, form.Month, form.State, 17, paginador.page, registers).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                paginador.setRegiPerPage(registers)

                setLista(resp.List);
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const validateForm = () => {
        let requiredFields = [
            "IDStore", "IssueDate", "AccountantConcept", "BussinesCore", "Project",
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            generate();
        }
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Items de la Remisión', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Remisión ${row.IDUBLInvoice}` }) } },
            { titulo: 'Generar Traslado a Almacén', icono: 'ri-save-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true, "name": `Generar Traslado a Almacén` }) } },
            { titulo: 'Ver Documento de Traslado', icono: 'ri-save-line', visible: true, evento: () => { getRemissionAccountant() } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const generate = () => {
        instance.createUBLRemissionFromStore(bean.IDStore, bean.AccountantConcept, bean.IssueDate, bean.Media, bean.MediaContex, _single.getAccountID(), bean.Observations, bean.BussinesCore, bean.Project).then(
            (resp: any) => {
                setModal({ ...modal, "view": false });
                getLista();
            }
        ).catch(err => { toast.error(err) });
    }

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'SupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Entrada Almacén', property: 'EAFMnemonic', visible: false, mask: MASK_DATE },
        { title: 'Consecutivo Entrada', property: 'EAFConsecutive', visible: false },
        { title: 'Fecha Entrada', property: 'EAFDate', visible: false, mask: MASK_DATE },
        { title: 'Fecha Procesamiento', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: false },
        { title: 'Estado Salidas', property: 'OutputCostStateName', visible: false },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: false },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const createFixed = () => {
        instance.createFixedAssetEntryForRemission(row.IDUBLInvoice, row.IssueDate, recordDate, recordStore, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true, "name": "Documento Generado" });
                    setModalC({ ...modalC, "view": false });
                }
            ).catch(err => toast.error(err));
    }

    const getRemissionAccountant = () => {
        instance.getRemissionAccountantDocument(row.IDUBLInvoice, row.IssueDate, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true, "name": "Documento Generado" });
                    setModalC({ ...modalC, "view": false });
                }
            ).catch(err => toast.error(err));
    }

    const create = () => {
        setBean({

        });
        setModal({ ...modal, "view": true, "name": "Remisión de Productos" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]



    return (
        <BasicPage titulo="Remisión de Productos desde Almacén">

            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={form.IDCustomer} label="Cliente" onChange={(e) => { setForm({ ...form, "IDCustomer": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <YearSelector onChange={(e) => { setForm({ ...form, "Year": e }) }} currentTerm value={form.Year} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <MonthConstantsEditor idSelect={form.Month} name="" onChange={(e) => { setForm({ ...form, "Month": e }) }} label="Mes" />
                </div>
                <div className="col-md-6">
                    <SelectRemissionStateConstantsFromStore idSelect={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} label="Estado" />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                </div>



                <div className="col-md-12">
                    <BasicTable
                        rowSet={(e) => { setRow(e) }}
                        listButtons={listaBotones()}
                        head={head} body={lista}
                        iconButtons={iconButtonsItem}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={registers}
                    />
                </div>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }} onSubmitLabel="Generar Remisión de Productos"  >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDStore') ? 'has-error' : ''}`}>Almacén</label>
                            <SelectStoreEditor label=" " idSelector={bean.IDStore} onChange={(e) => { setBean({ ...bean, "IDStore": e.IDStore }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('AccountantConcept') ? 'has-error' : ''}`}>Concepto de Ingreso de Facturación</label>
                            <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={bean.AccountantConcept} onChange={(e) => { setBean({ ...bean, "AccountantConcept": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IssueDate') ? 'has-error' : ''}`}>Fecha Remisión</label>
                            <InputDate label=" " name="" value={bean.IssueDate} setDate={(e) => { setBean({ ...bean, "IssueDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <FileInput onCreate={({ Media, MediaContext }) => { setBean({ ...bean, "Media": Media, "MediaContex": MediaContext }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, "Observations": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('BussinesCore') ? 'has-error' : ''}`}>Core de Negocio</label>
                            <SelectBusinessCore label=" " idSelector={bean.BussinesCore} onChange={(e) => { setBean({ ...bean, "BussinesCore": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Project') ? 'has-error' : ''}`}>Proyecto</label>
                            <SelectProject label=" " idSelector={bean.Project} onChange={(e) => { setBean({ ...bean, "Project": e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalB} updateModal={setModalB} >
                    <CreateUBLInvoiceItems idUBLInvoice={row.IDUBLInvoice} issueDate={row.IssueDate} _onChange={() => { getLista(); }} />
                </Modal>
            </div>


            <Modal modal={modalC} updateModal={setModalC} eventModal={createFixed} >
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
                    </div>
                    <div className="col-md-12">
                        <SelectStoreEditor label="Almacén" idSelector={recordStore} onChange={(e) => { setRecordStore(e.IDStore) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalVisor} updateModal={setModalVisor} >
                {/* visor de documentos */}
                <div className="row">
                    <div className="col-md-12">
                        {documentError.length > 0 ?
                            // <PrintJson json={documentError} />
                            <ul className="group-list">
                                {documentError.map((item: any, index: number) => {
                                    return (
                                        <li key={index} className="group-list-item">{item}</li>
                                    )
                                })}
                            </ul>
                            :
                            <>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}